import api from "../../API/apiConfig";

export const ACTIVITY_TYPES = {
  CONTACT: "CONTACT",
  ACCOUNT: "ACCOUNT",
  OPPORTUNITY: "OPPORTUNITY",
  LEAD: "LEAD"
}

export const getActivities = async (type, id) => {
  return await api.get(`/activities/${type}/${id}`);
};